import { useEffect, useState } from "react";

export default function EditProgrammeModal({
  isOpen,
  programme,
  onClose,
  onSave
}) {

  const [programName, setProgramName] = useState("");
  const [degree, setDegree] = useState("");
  const [applyUrl, setApplyUrl] = useState("");

useEffect(() => {
  if (programme) {
    setProgramName(programme.program_name || "");
    setDegree(programme.degree || "");
    setApplyUrl(programme.apply_url || "");
  }
}, [programme]);

  if (!isOpen) return null;

  return (

    <div className="admin-modal-overlay">

      <div className="admin-modal">

        <div className="admin-modal-header">

          <h2>Edit Programme</h2>

          <button
            className="admin-modal-close"
            onClick={onClose}
          >
            ×
          </button>

        </div>

        <div className="admin-modal-body">

            <div className="admin-form-group">

                <label>Programme Name</label>

                <input
                  type="text"
                  value={programName}
                  onChange={(e) => setProgramName(e.target.value)}
                />

            </div>

            <div className="admin-form-group">

              <label>Degree</label>

              <input
                type="text"
                value={degree}
                onChange={(e) => setDegree(e.target.value)}
              />

            </div>

            <div className="admin-form-group">

              <label>Application URL</label>

              <input
                type="text"
                value={applyUrl}
                onChange={(e) => setApplyUrl(e.target.value)}
              />

            </div>

            <div className="admin-modal-footer">

                <button
                className="admin-secondary-btn"
                onClick={onClose}
                >
                Cancel
                </button>

                <button
                  className="admin-primary-btn"
                  onClick={() =>
                    onSave({
                    ...programme,
                    program_name: programName,
                    degree,
                    apply_url: applyUrl
                  })
                  }
                >
                    Save Changes
                </button>

            </div>

            </div>

      </div>

    </div>

  );

}